import React, { useState, useEffect, useRef } from 'react';
import SEO from '../components/SEO';
import './Gallery.css';

// Gallery component with carousel functionality

const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedWork, setSelectedWork] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  // Remove isMobile, isFilterOpen, filterRef, and dropdown logic
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const categories = ['All', '2026', '2025', '2024', '2023', '2022'];



  const galleryWorks = [
    {
      id: 1,
      title: "Su-STAINED v2",
      category: "2026",
      image: "/images/gallery/su-stained-v2-new.jpg",
      medium: "Mixed Media: Acrylic & Gold Luxer Wax on Canvas",
      dimensions: "24\" x 48\"",
      year: "2026",
      caption: "It is still found in faith."
    },
    {
      id: 2,
      title: "The Sun Sets to Rise",
      category: "2025",
      image: "/images/gallery/sun-sets-to-rise-new.jpg",
      medium: "Mixed Media: Acrylic, Spray Paint & Marker on Canvas",
      dimensions: "24\" x 48\"",
      year: "2025",
      caption: "Weeping may endure for a night, but joy comes in the morning."
    },
    {
      id: 3,
      title: "The Last of Me",
      category: "2025",
      image: "/images/gallery/hanging-on.new.png",
      medium: "Mixed Media: Acrylic & Yarn on Canvas",
      dimensions: "30\" x 48\"",
      year: "2025",
      caption: "A powerful exploration of identity and transformation."
    },
    {
      id: 4,
      title: "The Value is Still In You",
      category: "2024",
      image: "/images/gallery/value-is-still-new.png",
      medium: "Mixed Media: Acrylic, Gold Luxer Wax, Spray Paint & Denim on Canvas",
      dimensions: "48\" x 60\"",
      year: "2024",
      caption: "A testament to inner worth and divine purpose."
    },
    {
      id: 5,
      title: "Fractured Flow",
      category: "2024",
      image: "/images/gallery/colorful-arms-new.png",
      medium: "Mixed Media: Acrylic & Spray Paint on Canvas",
      dimensions: "24\" x 48\"",
      year: "2024",
      caption: "The beauty in brokenness and the flow of healing."
    },
    {
      id: 6,
      title: "All I Need Is Love",
      category: "2024",
      image: "/images/gallery/all-we-need-new.png",
      medium: "Mixed Media: Acrylic & Plaster on Canvas",
      dimensions: "24\" x 48\"",
      year: "2024",
      caption: "A celebration of love as the foundation of all things."
    },
    {
      id: 7,
      title: "John 3:30",
      category: "2023",
      image: "/images/gallery/blue-guy-new.png",
      medium: "Mixed Media: Acrylic, Gold Luxer Wax on Canvas",
      dimensions: "30\" x 48\"",
      year: "2023",
      caption: "He must become greater; I must become less."
    },
    {
      id: 8,
      title: "Life Within HER",
      category: "2023",
      image: "/images/gallery/flower-hug-new.png",
      medium: "Mixed Media: Acrylic & Spray Paint on Canvas",
      dimensions: "36\" x 48\"",
      year: "2023",
      caption: "The nurturing power and creative force of the feminine."
    },
    {
      id: 9,
      title: "Eyes Watching",
      category: "2023",
      image: "/images/gallery/eyes-watching-new.png",
      medium: "Mixed Media: Acrylic & Glitter on Canvas",
      dimensions: "48\" x 24\"",
      year: "2023",
      caption: "The divine gaze that sees and knows all."
    },
    {
      id: 10,
      title: "Su-STAINED",
      category: "2022",
      image: "/images/gallery/colorful-face-new.png",
      medium: "Mixed Media: Acrylic & Gold Luxer Wax on Canvas",
      dimensions: "36\" x 48\"",
      year: "2022",
      caption: "The sustenance and strength found in faith."
    }
  ];

  const filteredWorks = selectedCategory === 'All' 
    ? galleryWorks 
    : galleryWorks.filter(work => work.category === selectedCategory);

  // Detail photo mappings
  const detailPhotoMappings = {
    'Su-STAINED v2': [
      '/images/gallery/su-stained-v2-new.jpg', // Main image
      '/images/detail/su-stained-v2/sustained1.jpg',
      '/images/detail/su-stained-v2/sustained2.jpg'
    ],
    'The Sun Sets to Rise': [
      '/images/gallery/sun-sets-to-rise-new.jpg', // Main image
      '/images/detail/sun-sets-to-rise/sunsets1.jpg',
      '/images/detail/sun-sets-to-rise/sunsets2.jpg'
    ],
    'The Last of Me': [
      '/images/gallery/hanging-on.new.png', // Main image
      '/images/detail/Hanging/body.png',
      '/images/detail/Hanging/Hand1.png'
    ],
    'The Value is Still In You': [
      '/images/gallery/value-is-still-new.png', // Main image
      '/images/detail/Value-is/face1.png',
      '/images/detail/Value-is/face2.png'
    ],
    'Fractured Flow': [
      '/images/gallery/colorful-arms-new.png', // Main image
      '/images/detail/colorarms/arm1.png',
      '/images/detail/colorarms/arm2.png'
    ],
    'All I Need Is Love': [
      '/images/gallery/all-we-need-new.png', // Main image
      '/images/detail/Need-Love/allineed1.png',
      '/images/detail/Need-Love/allineed2.png'
    ],
    'John 3:30': [
      '/images/gallery/blue-guy-new.png', // Main image
      '/images/detail/Blue-Guy/Blue1.png',
      '/images/detail/Blue-Guy/blue2.png'
    ],
    'Life Within HER': [
      '/images/gallery/flower-hug-new.png', // Main image
      '/images/detail/flower-hug/butterfly.png'
    ],
    'Su-STAINED': [
      '/images/gallery/colorful-face-new.png', // Main image
      '/images/detail/Colorface/Face1.png',
      '/images/detail/Colorface/face2.png'
    ]
  };

  // Get images for selected work
  const getWorkImages = (work) => {
    return detailPhotoMappings[work.title] || [work.image];
  };

  // Carousel navigation functions
  const nextImage = () => {
    if (selectedWork && !isTransitioning) {
      const images = getWorkImages(selectedWork);
      setIsTransitioning(true);
      setCurrentImageIndex((prevIndex) => 
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
      setTimeout(() => setIsTransitioning(false), 500);
    }
  };

  const prevImage = () => {
    if (selectedWork && !isTransitioning) {
      const images = getWorkImages(selectedWork);
      setIsTransitioning(true);
      setCurrentImageIndex((prevIndex) => 
        prevIndex === 0 ? images.length - 1 : prevIndex - 1
      );
      setTimeout(() => setIsTransitioning(false), 500);
    }
  };

  // Reset image index when work changes
  const handleWorkSelect = (work) => {
    setSelectedWork(work);
    setCurrentImageIndex(0);
    setIsTransitioning(false);
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedWork || isTransitioning) return;
      
      const images = getWorkImages(selectedWork);
      if (images.length <= 1) return;
      
      switch (e.key) {
        case 'ArrowLeft':
          e.preventDefault();
          prevImage();
          break;
        case 'ArrowRight':
          e.preventDefault();
          nextImage();
          break;
        case 'Escape':
          setSelectedWork(null);
          break;
        default:
          break;
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [selectedWork, currentImageIndex, isTransitioning]);

  // Close dropdown when clicking outside (for mobile)
  useEffect(() => {
    const handleClickOutside = (event) => {
      // This effect is no longer needed as the dropdown is removed.
      // Keeping it for now, but it will not be triggered.
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="gallery">
      <SEO 
        title="Gallery"
        description="A collection of works exploring beauty, spirituality, and identity. View my latest art pieces and creative expressions."
        image="/images/gallery/value-is-still-new.png"
        url="/gallery"
      />
      <div className="container">
        {/* Header */}
        <div className="gallery-header">
          <h1 className="gallery-title">ART <span className="brick-font">Gallery</span></h1>
          <p className="gallery-subtitle">
            A collection of works exploring beauty, spirituality, and identity.
          </p>
        </div>
        {/* Category Filters - pills are currently disabled. To restore, uncomment the block below. See GALLERY_FILTERS_README.md for details. */}
        {false && (
          <div className="category-filters">
            {categories.map((category) => (
              <button
                key={category}
                className={`filter-btn ${selectedCategory === category ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>
        )}

        {/* Gallery Grid */}
        <div className="gallery-grid">
          {filteredWorks.map((work) => (
            <div 
              key={work.id} 
              className="gallery-item"
              onClick={() => handleWorkSelect(work)}
            >
              <div className="gallery-image-container">
                <img 
                  src={work.image} 
                  alt={work.title} 
                  className="gallery-image"
                />
              </div>
              <div className="gallery-description">
                <h3 className="work-title">{work.title}</h3>
                <div className="work-details">
                  <span className="work-medium">{work.medium}</span>
                  <span className="work-dimensions">{work.dimensions}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Lightbox Modal */}
        {selectedWork && (
          <div className="lightbox" onClick={() => setSelectedWork(null)}>
            <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
              <button 
                className="lightbox-close"
                onClick={() => setSelectedWork(null)}
              >
                ×
              </button>
              <div className="lightbox-image-container">
                {(() => {
                  const images = getWorkImages(selectedWork);
                  const hasMultipleImages = images.length > 1;
                  
                  return (
                    <>
                      <div className="lightbox-image-wrapper">
                        <img 
                          src={images[currentImageIndex]} 
                          alt={`${selectedWork.title} - Image ${currentImageIndex + 1}`} 
                          className="lightbox-image active"
                        />
                      </div>
                      {hasMultipleImages && (
                        <>
                          <button 
                            className="lightbox-nav-btn lightbox-nav-prev"
                            onClick={prevImage}
                            aria-label="Previous image"
                          >
                            ‹
                          </button>
                          <button 
                            className="lightbox-nav-btn lightbox-nav-next"
                            onClick={nextImage}
                            aria-label="Next image"
                          >
                            ›
                          </button>
                          <div className="lightbox-indicators">
                            {images.map((_, index) => (
                              <button
                                key={index}
                                className={`lightbox-indicator ${index === currentImageIndex ? 'active' : ''}`}
                                onClick={() => setCurrentImageIndex(index)}
                                aria-label={`Go to image ${index + 1}`}
                              />
                            ))}
                          </div>
                        </>
                      )}
                    </>
                  );
                })()}
              </div>
              <div className="lightbox-info">
                <h2 className="lightbox-title">{selectedWork.title}</h2>
                <div className="lightbox-details">
                  <p><strong>Medium:</strong> {selectedWork.medium}</p>
                  <p><strong>Dimensions:</strong> {selectedWork.dimensions}</p>
                  <p><strong>Year:</strong> {selectedWork.year}</p>
                </div>
                <p className="lightbox-caption">{selectedWork.caption}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Gallery; 